import React from 'react';
import { Button, ChatIcon } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import { trackEventWithData } from '../utilsV3/analytics';
import { Message } from '@paypalcorp/worldready-react';
import { trackErrorIM } from '../../fpti/fpti';

const SPRIG_SURVEYS = {
  BUTTON_LINK: 'donatenodeweb-createManage_buttonLink-feedbacklink-nov2023-web',
  CAMPAIGN: 'donatenodeweb-createManage_campaign-feedbacklink-nov2023-web',
  MANAGE: 'donatenodeweb-managepage-feedbacklink-nov2023-web',
};

function DonateButtonFeedback({
  currentStep,
  fptiSpec,
  additionalData = {},
  invoker,
}) {
  const handleSprigSurvey = () => {
    if (window.latmconf && window.latmconf.trackSprigEvent) {
      trackEventWithData(fptiSpec, { step: currentStep, ...additionalData });
      window.latmconf.trackSprigEvent(SPRIG_SURVEYS[invoker]);
    } else {
      trackErrorIM({
        errorCode: 400,
        errorMessage:
          'window.latmconf or  window.latmconf.trackSprigEvent is undefined, Sprig not loaded',
        fieldName: SPRIG_SURVEYS[invoker],
      });
    }
  };

  return (
    <Button
      className="feedback"
      type="button"
      onClick={handleSprigSurvey}
      iconComponent={ChatIcon}
      tertiary
    >
      <Message id="buttonsV3.common.buttonFeedback" />
    </Button>
  );
}

DonateButtonFeedback.propTypes = {
  currentStep: PropTypes.number,
  fptiSpec: PropTypes.object,
  additionalData: PropTypes.object,
  invoker: PropTypes.string,
};

export default DonateButtonFeedback;
